export const mediaQueries = {
    mobile: `@media (max-width: 480px)`,
    tablet: `@media (min-width: 481px) and (max-width: 1024px)`,
    // laptop: `@media (min-width: 1025px) and (max-width: 1440px)`,
    // desktop: `@media (min-width: 1441px)`,
};

export const mainDivStyle = {
    background: 'beige',
    fontWeight: 'bold',
    minWidth: "320px",
    paddingBottom: "10px",
}

export const subDivStyle = {
    padding: "12px 0px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
}

export const fieldsetStyle = {
    display: "inline-block",
    margin: "0px 3px",
    borderRadius: "10px",
    maxWidth: "18.5%"
}

export const columnStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
}

export const selectStyle = {
    outline: 'none',
    padding: "5px 2px",
    width: "255px",
    borderRadius: "5px",
}

export const lodButton = {
    width: "255px",
    fontSize: "12.5px",
}

export const loadingSpace = {
    height: "35rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
}

export const dsiplayMesgStyle = {
    paddingLeft: "40px",
    fontWeight: "bold",
    color: "blue"
}

export const verylightGray = {
    backgroundColor: "#CDCDCD"
}

export const mainGraphDivStyle = {
    background: "lightGray",
    fontWeight: "bold",
};

export const selectGraphStyle = {
    outline: 'none',
    margin: '10px',
    height: '25px',
};

export const loadingGraphBox ={
    height: "500px", 
    display: "flex", 
    justifyContent: "center", 
    alignItems: "center"
}

export const containerGraphStyle = {
    width: "100%",
    height: "auto",
    margin: "auto",
    paddingBottom: "10px",
};

export const tablestyle = {
    border: "1px solid gray",
    textAlign: "center",
    borderRadius: "4px",
    whiteSpace: 'normal',
    overflow: 'hidden',
    wordBreak: 'break-word',
    fontSize: window.innerWidth < 500 ? "12px" : "1rem",
}